import React from 'react'
import { COUNTRIES } from './CountrySelectorConst'
import { CountrySelectorFlagIcon } from './CountrySelectorFlagIcon'

/**
 * The dropdown component for the country selector.
 * It displays a list of countries with their flags and links.
 */
export const CountrySelectorDropDown = React.memo(function ({
  isOpen
}: { readonly isOpen: boolean }) {
  return (
    <ul
      className={`absolute bg-white bottom-[calc(100%-20px)] list-none min-w-fit my-5 pl-0 shadow-[-2px_2px_6px_0_rgba(0,0,0,0.18)] w-full z-10 not-prose whitespace-nowrap left-0
        after:-z-[1] after:absolute  after:bg-white after:bottom-0 after:content-[''] after:h-4 after:rotate-45 after:translate-y-1/2 after:w-4 after:left-9
        ${isOpen ? 'flex flex-col items-center justify-start' : 'hidden'}
        md:-left-20 after:md:right-12 after:md:left-auto
        xl:-left-10 after:xl:right-auto
      `}
      data-testid="countrySelectorList"
    >
      <li className="w-full flex hover:bg-neutral-light-50 m-0 px-4 h-14 items-center transition-colors duration-200">
        <a
          className="flex gap-2.5 no-underline active:no-underline text-neutral-black marker:active:text-neutral-black hover:underline"
          href={COUNTRIES['en-GB'].url}
        >
          <CountrySelectorFlagIcon
            src={COUNTRIES['en-GB'].src}
            alt={COUNTRIES['en-GB'].alt}
          />
          {COUNTRIES['en-GB'].text}
        </a>
      </li>
      <li className="w-full flex hover:bg-neutral-light-50 m-0 px-4 h-14 items-center transition-colors duration-200">
        <a
          className="flex gap-2.5 no-underline active:no-underline text-neutral-black marker:active:text-neutral-black hover:underline"
          href={COUNTRIES['en-US'].url}
        >
          <CountrySelectorFlagIcon
            src={COUNTRIES['en-US'].src}
            alt={COUNTRIES['en-US'].alt}
          />
          {COUNTRIES['en-US'].text}
        </a>
      </li>
    </ul>
  )
})
